<template>
  <div class="other-link">
    <!-- <i class="icon-i logoIcon"></i> -->
    <a-alert class="alert-box" :message="online_url" description="移动端请复制链接到pc端打开" type="warning" />
  </div>
</template>

<script>
export default {
  name: "warningroot",
  data() {
    return {
      user: null,
      online_url: ''
    }
  },
  async mounted() {
    let { type } = this.$route.params;
    this.online_url = `https://lessonplay_shell.lessonplan.cn/${type}`;

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "./warning.scss";
</style>